<template>
  <div class="goods-list">
    <div class="img-con">
      <img class="img" :src="'http://img13.360buyimg.com/n2/'+item2.mapProductDetail.coverImage" alt="">
    </div>
    <div class="info-con">
      <div class="title">{{ item2.mapProductDetail.title }}</div>
      <div class="total">
        <span class="now-price">￥{{ item2.mapPrice.sellPrice }}</span>
        <s class="old-price">原价:￥{{ item2.mapPrice.displayOriginalPrice }}</s>
        <span class="num">x{{ item2.productCount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item2: {
      required: true
    },
  },
}
</script>

<style lang="less" scoped>
.goods-list{
  padding: 15px 12px;
  display: flex;
  font-size: 14px;
  .img-con{
    display: inline-flex;justify-content: center;align-items: center;
    width: 85px;height: 100%;
    .img{width: 85px;height: 85px;border-radius: 8px;}
  }
  .info-con{
    display: inline-flex;flex-direction: column;justify-content: space-between;
    flex: 1;padding: 5px 0 5px 6px;
    .title{
      width: 100%;height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .total{
      width: 100%;
      display: flex;justify-content: flex-end;align-items: flex-end;font-size: 14px;
      .now-price{color: #f74d4d;margin-right: 10px;}
      .old-price{color: #999;margin-right: 10px;font-size: 10px;}
      .num{color: #666;margin-left: auto;margin-right: 0;}
    }
  }
}
</style>